import { useState, useEffect } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { usePageTransition } from '../context/TransitionContext.jsx';
import { getPost } from '../data/blog/index.js';
import '../assets/css/src/blog.css';

export default function BlogPost() {
  const { slug } = useParams();
  const { navigateTo } = usePageTransition();
  const location = useLocation();
  const post = getPost(slug);

  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!post) return;
    setContent(null);
    setError(false);
    fetch(`/blog/posts/${post.slug}.md`)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');
        return res.text();
      })
      .then(setContent)
      .catch(() => setError(true));
  }, [post]);

  if (!post) return <Navigate to="/blog" replace />;

  function handleBack(e) {
    e.preventDefault();
    if (location.pathname === '/blog') return;
    navigateTo('/blog');
  }

  return (
    <section className="page-content">
      <article className="blog-post">
        <a href="/blog" className="blog-back" onClick={handleBack}>
          ← All posts
        </a>
        <header className="blog-post-header">
          <time className="blog-date">
            {new Date(post.date).toLocaleDateString('en-CA', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </time>
          {/* <h1>{post.title}</h1> */}
        </header>
        <div className="blog-post-content">
          {error && <p>Could not load post content.</p>}
          {!error && content === null && <p className="blog-loading">Loading…</p>}
          {!error && content !== null && <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>}
        </div>
      </article>
    </section>
  );
}
